import React, { Component } from "react";
import styles from './styles.css'

import Container from '../../../components/Container'
import Title from '../../../components/Title'

import iconMovie from './cd-icon-movie.svg'
import iconPicture from './cd-icon-picture.svg'
import iconLocation from './cd-icon-location.svg'

class Experience extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <div>
        <Title direction='right'>Experience</Title>
        <section className="cd-timeline js-cd-timeline">
          <div className="cd-timeline__container">
            <div className="cd-timeline__block js-cd-block">
              <div className="cd-timeline__img cd-timeline__img--picture js-cd-img">
                <img src={iconPicture} alt="Picture"></img>
              </div>

              <div className="cd-timeline__content js-cd-content">
                <h2>Envato - Developer</h2>
                <p>Working in the customer, traffic team to provide users with a fast and friendly experience when visiting Envato sites.</p>
                <span className="cd-timeline__date">July, 2018</span>
              </div>
            </div>

            <div className="cd-timeline__block js-cd-block">
              <div className="cd-timeline__img cd-timeline__img--movie js-cd-img">
                <img src={iconMovie} alt="Movie"></img>
              </div>

              <div className="cd-timeline__content js-cd-content">
                <h2>Bona Fide Design Co - Freelance Web Developer</h2>
                <p>
                  Building side projects and contracting with a Design Agency called Bona Fide Design Co to offer web solutions on their behalf.
                </p>
                <ul>
                  <li>Custom Wordpress theme development.</li>
                  <li>Use of modern technologies including HTML5, SCSS, Webpack, Blade Templating.</li>
                  <li>Website Hosting and Server Configuration.</li>
                  <li>Experimenting with technologies including React and React Native.</li>
                </ul>
                <span className="cd-timeline__date">March, 2018</span>
              </div>
            </div>

            <div className="cd-timeline__block js-cd-block">
              <div className="cd-timeline__img cd-timeline__img--picture js-cd-img">
                <img src={iconPicture} alt="Picture"></img>
              </div>

              <div className="cd-timeline__content js-cd-content">
                <h2>Copirite - Ruby Developer</h2>
                <p>
                  Copirite is a Gold Coast based company which specialises in Design, Print, Signage and Web based services.
                </p>
                <ul>
                  <li>Managed internal systems built using Ruby on Rails.</li>
                  <li>Custom Wordpress theme development for client websites.</li>
                  <li>Configured continuous deployment and performed server maintenance.</li>
                  <li>Proficient frontend development using HTML5, SCSS and Webpack.</li>
                  <li>Experimented with JavaScript frameworks (Stimulus, React) for custom features.</li>
                  <li>Developed and maintained a research foundation website for P.A Hospital in Ruby on Rails with fully custom CMS and e-commerce platform (Stripe and PayPal Integration).</li>
                </ul>
                <span className="cd-timeline__date">June, 2015</span>
              </div>
            </div>

            <div className="cd-timeline__block js-cd-block">
              <div className="cd-timeline__img cd-timeline__img--location js-cd-img">
                <img src={iconLocation} alt="Location"></img>
              </div>

              <div className="cd-timeline__content js-cd-content">
                <h2>iOnline - PHP Developer</h2>
                <p>
                  iOnline is a digital agency based in Gold Coast, Australia which provides website design and development services to companies Australia wide.
                </p>
                <ul>
                  <li>Created and maintained client websites in PHP which integrated with iOnline’s custom CMS platform.</li>
                  <li>Communicated with clients directly and issues bug fixes.</li>
                  <li>Proficient frontend development using HTML5, SCSS and Grunt</li>
                </ul>
                <span className="cd-timeline__date">September, 2013</span>
              </div>
            </div>

            <div className="cd-timeline__block js-cd-block">
              <div className="cd-timeline__img cd-timeline__img--location js-cd-img">
                <img src={iconLocation} alt="Location"></img>
              </div>

              <div className="cd-timeline__content js-cd-content">
                <h2>Griffith University - Bachelor of Information Technology (Advanced)</h2>
                <ul>
                  <li>Advanced learning of C/C++.</li>
                  <li>Completed an additional advanced assessment per semester.</li>
                  <li>Industry Project developed using Laravel and AngularJS.</li>
                </ul>
                <span className="cd-timeline__date">2012</span>
              </div>
            </div>

            <div className="cd-timeline__block js-cd-block">
              <div className="cd-timeline__img cd-timeline__img--movie js-cd-img">
                <img src={iconMovie} alt="Movie"></img>
              </div>

              <div className="cd-timeline__content js-cd-content">
                <h2>Born</h2>
                <p>The birth of Matt Patterson</p>
                <span className="cd-timeline__date">4 July 1994</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default Experience



// WEBPACK FOOTER //
// ./src/parts/home/Experience/index.js